import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
} from "@mui/material";
import { DataGrid, GridColDef, GridRowParams } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import { DataCodeEnum } from "../../constants/enum";
import { ENDPOINTS, getApiUrl } from "../../common/endpoints";
import { Requests } from "../../common/requests";
import { useSnackbar } from "notistack";
import AddIcon from "@mui/icons-material/Add";
import TogglePublicBtn from "../TogglePublicBtn";
interface Field {
  code: string;
  name: string;
}

interface DataContentProps {
  code: DataCodeEnum;
  name: string;
  fields: Field[];
}

const DataContent = ({ code, name, fields }: DataContentProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const [dataContent, setDataContent] = useState<any>(null);
  const [data, setData] = useState<any[]>([]);
  const [dataEdit, setDataEdit] = useState<any[]>([]);
  const [selectedElement, setSelectedElement] = useState<any | null>(null);
  const [isEdit, setIsEdit] = useState(false);

  const handleRowClick = (params: GridRowParams) => {
    setSelectedElement(params.row);
  };

  const handleClose = () => {
    setSelectedElement(null);
  };
  const fetchData = async () => {
    const apiUrl = getApiUrl(
      ENDPOINTS.SAVE_PAGE_CONTENT.replace(":dataCode", code)
    );
    try {
      const data = await Requests.get(apiUrl);
      setDataContent(data);
      if (Array.isArray(data?.content?.data)) {
        setData(data?.content?.data);
      }
    } catch (e) {}
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSave = async () => {
    const apiUrl = getApiUrl(
      ENDPOINTS.SAVE_PAGE_CONTENT.replace(":dataCode", code)
    );

    try {
      await Requests.post(apiUrl, {
        dataName: name,
        content: {
          data: dataEdit,
        },
      });
      setData(dataEdit);
      setIsEdit(false);
      enqueueSnackbar("Save successfully!", { variant: "success" });
    } catch (e) {
      enqueueSnackbar("Save unsuccessfully!", { variant: "error" });
    }
  };

  const onTogglePublish = async () => {
    const apiUrl = getApiUrl(
      ENDPOINTS.TOGGLE_PUBLISH_PAGE_CONTENT.replace(":dataCode", code)
    );

    try {
      const data = await Requests.patch(apiUrl, {
        dataName: name,
      });
      fetchData();
      enqueueSnackbar("Toggle publish success!", { variant: "success" });
    } catch (e) {}
  };

  const columns: GridColDef[] = fields.map((field) => ({
    field: field.code,
    headerName: field.name,
    flex: 1,
    // width: 150,
  }));

  return (
    <Box
      p={2}
      sx={{
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {isEdit ? (
          <>
            <Button
              variant="contained"
              color="primary"
              sx={{
                textTransform: "unset",
              }}
              onClick={() => {
                onSave();
              }}
            >
              Save
            </Button>

            <Button
              variant="contained"
              color="secondary"
              sx={{
                textTransform: "unset",
                marginLeft: "5px",
              }}
              onClick={() => {
                setIsEdit(false);
                setDataEdit([]);
              }}
            >
              Cancel
            </Button>
          </>
        ) : (
          <Button
            variant="contained"
            color="primary"
            sx={{
              textTransform: "unset",
            }}
            onClick={() => {
              setIsEdit(true);
              setDataEdit(data);
            }}
          >
            Edit
          </Button>
        )}
        <TogglePublicBtn
          isValidated={!!dataContent?.ispublished}
          onToggle={() => {
            onTogglePublish();
          }}
        />
      </Box>
      <Box style={{ width: "100%" }}>
        {isEdit ? (
          <Box>
            {dataEdit.map((item, index) => {
              return (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                  }}
                >
                  {fields.map((field) => (
                    <Box
                      sx={{
                        padding: "4px",
                        flex: 1,
                      }}
                    >
                      <TextField
                        color="primary"
                        margin="dense"
                        label={field.name}
                        type="text"
                        multiline
                        rows={4}
                        value={item[field.code]}
                        onChange={(event) =>
                          setDataEdit((prev) =>
                            prev.map((itemP, indexP) =>
                              indexP === index
                                ? { ...itemP, [field.code]: event.target.value }
                                : itemP
                            )
                          )
                        }
                        sx={{
                          width: "100%",
                          backgroundColor: "#F7FAFC",
                          border: "none",
                          "& label": {
                            color: "#2A4365",
                            fontWeight: "bold",
                          },
                          "& fieldset": {
                            border: "none!important",
                          },
                          "& .MuiInputBase-root": {
                            padding: "10px",
                            color: "#2A4365",
                          },
                        }}
                      />
                    </Box>
                  ))}

                  <Box>
                    <IconButton
                      color="secondary"
                      onClick={() => {
                        setDataEdit((prev) =>
                          prev.filter((itemP, indexP) => index !== indexP)
                        );
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                </Box>
              );
            })}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                paddingBottom: "10px",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={() => {
                  setDataEdit((prev) => [
                    ...prev,
                    {
                      name: "",
                      sign_ruled: "",
                      on_a_good_day: "",
                      on_a_bad_day: "",
                      how_to_win: "",
                    },
                  ]);
                }}
              >
                Add
              </Button>
            </Box>
          </Box>
        ) : (
          <DataGrid
            rows={data.map((item, index) => ({
              ...item,
              data_index: index,
            }))}
            columns={columns}
            getRowId={(row) => row.data_index}
            onRowClick={handleRowClick}
            rowHeight={80}
            sx={{
              padding: "10px",
              border: "none!important",
              "& .MuiDataGrid-columnHeaders": {
                "& > div": {
                  "& > div": {
                    border: "none!important",
                  },
                },
              },
              "& .MuiDataGrid-columnHeader": {
                border: "none!important",
              },
              "& .MuiDataGrid-filler": {
                border: "none!important",
              },
              "& .MuiDataGrid-scrollbarFiller": {
                border: "none!important",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                color: "#2A4365",
                fontWeight: "bold",
              },
              "& .MuiDataGrid-row": {
                height: "80px!important",
                minHeight: "80px!important",
                backgroundColor: "#F7FAFC",
                margin: "4px 0",
                borderRadius: "10px",
              },
              "& .MuiDataGrid-cell": {
                padding: "10px",
                color: "#2A4365",
                height: "80px!important",
                minHeight: "80px!important",
                border: "none!important",
              },
              "& .MuiDataGrid-cellEmpty": {
                display: "none",
              },
              "& .MuiTablePagination-root": {
                color: "#2A4365",
              },
            }}
          />
        )}
      </Box>

      {selectedElement && (
        <Dialog open={Boolean(selectedElement)} onClose={handleClose}>
          <DialogTitle
            color="primary"
            sx={{
              fontWeight: "bold",
            }}
          >
            {selectedElement.name} Details
          </DialogTitle>
          <DialogContent>
            {fields.map((item) => (
              <Typography
                sx={{
                  fontSize: "14px",
                }}
              >
                <strong>{item.name}:</strong> {selectedElement[item.code] ?? ""}
              </Typography>
            ))}
          </DialogContent>
          <DialogActions>
            <Button
              sx={{
                textTransform: "unset",
              }}
              onClick={handleClose}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
};

export default DataContent;
